import { Box, FileSelector, Icon, LoaderNew, ModBox, Spacer, Text, TextNew } from '@jfs/ui-new'
import { isEmptyObject } from '@jfs/utils'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import XlsxPopulate from 'xlsx-populate'
import { ButtonNew } from '../../components/AdminButton'
import { DualActionButtonComp } from '../../components/DualActionButtonComp'
import { FileSelectorInnerComp } from '../../components/FileSelectorInnerComp'
import { useLazyApiData, useStores } from '../../data/store'
import { MessageTypes } from '../../utils'
import { EmType } from '../EntityManagement'
import { styles } from './styles'
import { UserDataDownloadComp } from './UserDataDownloadComp'

const columnsMapper = {
  bulkConfig: ['mid', 'config', 'configList'],
  bulkUpload: ['entityId', 'parentIdentificationNumber', 'parentType'],
  bulkCard: ['mid', 'CARD_TYPE', 'IS_DOMESTIC_ALLOWED', 'IS_INTERNATIONAL_ALLOWED', 'IS_PREMIUM', 'ACTION'],
  bulkVpa: ['mid', 'terminalId', 'vpa', 'program_identifier', 'bank', 'is_EntityVPA'],
  bulkStore: [
    'SMID',
    'Store Manager First Name',
    'Store Manager Last Name',
    'Store Manager Mobile',
    'Store Add1',
    'Store Add2',
    'Store City',
    'Store State',
    'Store Pincode',
    'MCC Code',
    'Bank Account Name',
    'Bank Account Number',
    'IFSC Code',
    'Parent Settlement Flag',
    'Merchant Business Name',
    'Year Of Business',
    'Daily Txn Value',
    'Daily Txn Number',
    'Store Code',
    'Format',
    'Settlement Frequency',
  ],
  bulkTerminal: ['TID Username', 'TID Nickname', 'MID', 'Terminal Type', 'VPA', 'Program Identifier'],
  MCC_EXPORT: ['MCC', 'Business Category', 'Business Line', 'Risk Category', 'Action'],
  IFSC_EXPORT: ['IFSC Code', 'Bank Name', 'City', 'Branch', 'Action'],
  PINCODE_EXPORT: ['Pincode', 'City', 'StateName', 'Action'],
  PROGRAM_CATEGORY_EXPORT: [
    'ProgramID',
    'ProgramName',
    'MCC',
    'OwnershipType',
    'RefID Validation',
    'StartDate',
    'End Date',
    'Action',
  ],
  BULK_STORE_UPDATE: [
    'superMerchantId',
    'merchantId',
    'businessCategory',
    'merchantStatus',
    'GSTNumber',
    'GSTCategory',
    'companyType',
    'mcc',
    'businessLegalName',
    'businessName',
    'latitude',
    'longitude',
    'locAddressLine1',
    'locAddressLine2',
    'locCity',
    'locState',
    'locZip',
    'locEmailId',
    'locAddressType',
    'crpAddressLine1',
    'crpAddressLine2',
    'crpAddressType',
    'crpCity',
    'crpState',
    'crpZip',
    'crpEmailId',
    'Bank Account Name',
    'Bank Account Number',
    'IFSC Code',
    'Parent Settlement Flag',
    'Store Code',
    'Format',
    'Settlement Frequency',
    'FeePkgID',
    'Year Of Business',
    'Daily Txn Value',
    'Daily Txn Number',
  ],
  BULK_DEVICES: ['Device Serial No', 'imei', 'Device Type', 'dongleKeyAlias', 'Action'],
  BULK_TERMINAL_UPDATE: [
    'merchantId',
    'TID',
    'Username',
    'Nickname',
    'issueRefunds',
    'acceptPayment',
    'terminalStatus',
  ],
  ADD_MERCHANT_MAPPING: [
    'id',
    'merchantType',
    'merchantId',
    'terminalID',
    'processingEntityID',
    'bankMID',
    'txnType',
    'instrumentType',
    'txnMode',
    'mappingStatus',
    'reqType',
    'pgSecurityId',
    'secret',
    'cipher',
    'mcfg1',
    'mcfg2',
    'emiCode',
    'pinMasterKey',
    'pinMasterKcv',
    'dataMasterKey',
    'dataMasterKcv',
    'bankTID',
    'batchNo',
    'merchantStatus',
  ],
  BULK_KEY_EXCHANGE_UPLOAD: [
    'id',
    'merchantId',
    'terminalID',
    'processingEntityID',
    'bankMID',
    'txnType',
    'instrumentType',
    'bankTID',
  ],
  APPROVE_MERCHANT_MAPPING: [
    'id',
    'merchantType',
    'merchantId',
    'terminalID',
    'processingEntityID',
    'bankMID',
    'txnType',
    'instrumentType',
    'txnMode',
    'mappingStatus',
    'reqType',
    'pgSecurityId',
    'secret',
    'cipher',
    'mcfg1',
    'mcfg2',
    'emiCode',
    'pinMasterKey',
    'pinMasterKcv',
    'dataMasterKey',
    'dataMasterKcv',
    'bankTID',
    'batchNo',
    'merchantStatus',
    'workflowId',
    'approvalAction',
  ],
  BATCH_MAKER: ['bankMid', 'bankTid', 'batchNo', 'createdAt', 'mid', 'processingEntityId', 'status', 'tid', 'Action'],
  BATCH_CHECKER: [
    'mid',
    'tid',
    'bankMid',
    'bankTid',
    'batchNo',
    'processingEntityId',
    'batchStatus',
    'createdAt',
    'status',
    'workflowId',
    'Action',
  ],
  BULK_USER_MANAGEMENT: [
    'mobileNumber',
    'firstName',
    'lastName',
    'email',
    'entityId',
    'userType',
    'permissions',
    'userStatus',
    'Action',
  ],
  CHECKER_1_BULK_CLAIM: [
    'ApplicationId',
    'Legal Name',
    'Mobile Number',
    'Request Type',
    'Created At',
    'Application State',
  ],
  CHECKER_2_BULK_CLAIM: [
    'ApplicationId',
    'Legal Name',
    'Mobile Number',
    'Request Type',
    'Created At',
    'Application State',
  ],
  CHECKER_1_BULK_ACTION: [
    'ApplicationId',
    'Legal Name',
    'Mobile Number',
    'Request Type',
    'Created At',
    'Application State',
    'Group Id',
    'Sub GroupId',
    'Action',
    'Checker Comments',
  ],
  CHECKER_2_BULK_ACTION: [
    'ApplicationId',
    'Legal Name',
    'Mobile Number',
    'Request Type',
    'Created At',
    'Application State',
    'Action',
    'Checker Comments',
  ],
}

const columns = (type) => columnsMapper[type] || ['entityId']
interface EmiFileUploadType {
  type:
    | 'default'
    | 'bulkUpload'
    | 'tid'
    | 'documentation'
    | 'bulkConfig'
    | 'bulkCard'
    | 'bulkVpa'
    | 'bulkStore'
    | 'bulkTerminal'
    | 'MCC_EXPORT'
    | 'IFSC_EXPORT'
    | 'PINCODE_EXPORT'
    | 'PROGRAM_CATEGORY_EXPORT'
    | 'BULK_TERMINAL_UPDATE'
    | 'BULK_TERMINAL_UPDATE'
    | 'BULK_STORE_UPDATE'
    | 'BULK_DEVICES'
    | 'BULK_TERMINAL_UPDATE'
    | 'ADD_MERCHANT_MAPPING'
    | 'BULK_KEY_EXCHANGE_UPLOAD'
    | 'APPROVE_MERCHANT_MAPPING'
    | 'BULK_USER_MANAGEMENT'

  title?: string
  dropText?: string
  onReviewPressed?: (val: boolean) => void
  updateUploadedExcelFile?: (emiInfo: any) => void
  updateFileName?: (fileName: any) => void
  fileType:
    | '.csv'
    | '.doc'
    | '.xlsx'
    | '.xls,.xlsx,.xlsb'
    | ''
    | '.png'
    | '.xls,.xlsx,.xlsb,.doc,.docx,.pdf,.jpg,.jpeg,.png'

  documentFormData?: any
  flowType?: string
  showRemoveFile?: boolean
  identificationNumber?: string
  onDismiss?: () => void
}

const showOutlinedButton = (loading: boolean, filename: string) => {
  if (loading) {
    return true
  } else if (filename?.length > 1) {
    return true
  }
  return false
}

const coloredButtonString = (filename: string) => {
  return 'Review uploaded file'
}

const getOutlineButtonString = (loading: boolean, filename: string) => {
  if (loading) {
    return 'Cancel Onboarding'
  } else if (filename?.length > 1) {
    return 'Cancel Onboarding'
  }
  return ''
}

const headerIndexMap = {
  MCC_EXPORT: 2,
  IFSC_EXPORT: 2,
  PINCODE_EXPORT: 2,
  PROGRAM_CATEGORY_EXPORT: 2,
  BULK_TERMINAL_UPDATE: 2,
  ADD_MERCHANT_MAPPING: 2,
  BULK_PAYMENT_CONFIG: 2,
  BULK_KEY_EXCHANGE_UPLOAD: 2,
  BULK_STORE_UPDATE: 3,
}

const getHeaderIndex = (type) => headerIndexMap[type] || 1

const sampleFileMap = {
  bulkConfig: 'sample_bulk_config',
  tid: 'sample_bulk_sync',
  bulkCard: 'sample_bulk_card',
  bulkVpa: 'sample_bulk_vpas',
  bulkStore: 'sample_bulk_store',
  bulkTerminal: 'sample_bulk_terminal',
  MCC_EXPORT: 'sample_bulk_mcc',
  IFSC_EXPORT: 'sample_bulk_ifsc',
  PINCODE_EXPORT: 'sample_bulk_pincode',
  PROGRAM_CATEGORY_EXPORT: 'sample_bulk_programCategory',
  BULK_STORE_UPDATE: 'sample_bulk_store_update',
  BULK_DEVICES: 'sample_bulk_devices_add',
  BULK_TERMINAL_UPDATE: 'sample_bulk_terminal_update',
  ADD_MERCHANT_MAPPING: 'sample_merchant_payment_config',
  BULK_KEY_EXCHANGE_UPLOAD: 'sample_key_exchange',
  APPROVE_MERCHANT_MAPPING: 'sample_bulk_merchant_config_review',
  BULK_USER_MANAGEMENT: 'sample-bulk-usermanagement',
}

const getSampleFileName = (sampleType) => sampleFileMap[sampleType] || 'sample_bulk_entity'

const EmiFileUpload = React.memo(
  ({
    type = 'default',
    title,
    dropText,
    onReviewPressed,
    updateUploadedExcelFile,
    updateFileName,
    fileType,
    documentFormData,
    flowType,
    showRemoveFile,
    identificationNumber = '',
    onDismiss,
  }: EmiFileUploadType) => {
    const {
      setMessage,
      saveEmiInfo,
      setEmiFileUpload,
      bulkOnboardfileUpload,
      bulkOnboardingDelete,
      sampleFileDownload,
      fileUploaded,
      uploadedFileId,
      setFileUploaded,
      kycUploadFile,
      getDocumentDataByFileName,
      addDocument,
      kycFetchUploadId,
      uploadId,
      exportByJobIdAsync,
    } = useStores((store) => ({
      setMessage: store.message.setMessage,
      saveEmiInfo: store.onboarding.saveEmiInfo,
      setEmiFileUpload: store.setEmiFileUpload,
      bulkOnboardfileUpload: store.bulkOnboardfileUpload,
      bulkOnboardingDelete: store.bulkOnboardingDeleteReq,
      sampleFileDownload: store.sampleFileDownload,
      fileUploaded: store.bulkEntity.fileUploaded,
      uploadedFileId: store?.bulkEntity?.uploadedFile?.id,
      setFileUploaded: store?.setFileUploaded,
      kycUploadFile: store.kycUploadFile,
      getDocumentDataByFileName: store.getDocumentDataByFileName,
      addDocument: store.addDocument,
      kycFetchUploadId: store.kycFetchUploadId,
      uploadId: store.onboarding.uploadId,
      exportByJobIdAsync: store.exportByJobIdAsync,
    }))

    const isDefaultType = type === 'default'
    // const isBulkUploadType = type === 'bulkUpload'

    const [saveEmiInfoApi] = useLazyApiData(saveEmiInfo)
    const [bulkOnboardUploadFile, bulkOnboardfileUploadHandler] = useLazyApiData(bulkOnboardfileUpload)
    const [fetchKycUploadId, uploadIdHandler] = useLazyApiData(kycFetchUploadId)
    const [lazyDownloadExistingLovRecords, downloadExistingLovHandler] = useLazyApiData(exportByJobIdAsync)

    const [uploadKyc, uploadKycHandler] = useLazyApiData(kycUploadFile)

    const [loading, setLoading] = useState(false)
    const [percent, setPercent] = useState(0)
    const [emiInfo, setEmiInfo] = useState()
    const [wsdata, setWsData] = useState<XlsxPopulate.Workbook>()
    const [filename, setFilename] = useState('')
    const [fileId, setFileId] = useState('')
    const [file, setFile] = useState(null)

    useEffect(() => {
      if (uploadIdHandler?.state === 'fulfilled' && file !== null) {
        uploadKyc(
          file,
          documentFormData?.MERCHANT_DOCUMENT_TYPE,
          documentFormData?.RID,
          flowType === 'AD_MAKER' ? documentFormData?.NAME : documentFormData?.MERCHANT_DOCUMENT_NAME,
          documentFormData?.expiry ?? '',
          flowType === EmType.createGroup
            ? 'GROUP'
            : flowType === EmType.createSubGroup
            ? 'SUBGROUP'
            : flowType === EmType.createSingleEntity
            ? 'ENTITY'
            : 'REDACT',
          uploadId,
          identificationNumber,
        )
        setFile(null)
      } else if (uploadIdHandler?.state === 'rejected') {
        setWsData(undefined)
        setLoading(false)
        setPercent(0)
        setFileId('')
        updateUploadedExcelFile && updateUploadedExcelFile('')
        updateFileName && updateFileName('')
      }
    }, [
      documentFormData?.MERCHANT_DOCUMENT_NAME,
      documentFormData?.MERCHANT_DOCUMENT_TYPE,
      documentFormData?.RID,
      documentFormData?.expiry,
      file,
      flowType,
      updateFileName,
      updateUploadedExcelFile,
      uploadId,
      uploadIdHandler?.state,
      uploadKyc,
      identificationNumber,
      documentFormData?.NAME,
      documentFormData?.TRANSACTION_ID,
    ])

    useEffect(() => {
      if (uploadKycHandler?.state === 'fulfilled') {
        setFilename(uploadKycHandler?.data?.data?.fileName)
        setLoading(false)
        setEmiFileUpload(true)
        setFileId(uploadKycHandler?.data?.data?.id)
        updateUploadedExcelFile &&
          updateUploadedExcelFile({ name: uploadKycHandler?.data?.data?.fileName, uploadId: uploadId })
        updateFileName && updateFileName(filename)
        setPercent(100)
      }
    }, [
      filename,
      setEmiFileUpload,
      updateFileName,
      updateUploadedExcelFile,
      uploadId,
      uploadKycHandler?.data?.data?.fileName,
      uploadKycHandler?.data?.data?.id,
      uploadKycHandler?.state,
    ])

    useEffect(() => {
      if (fileUploaded && uploadedFileId) {
        setLoading(false)
        setEmiFileUpload(true)
        setFileId(uploadedFileId)
        setPercent(100)
      }
    }, [fileUploaded, setEmiFileUpload, uploadedFileId])

    useEffect(() => {
      if (
        bulkOnboardfileUploadHandler.state === 'fulfilled' &&
        bulkOnboardfileUploadHandler?.data &&
        bulkOnboardfileUploadHandler?.data?.data?.id
      ) {
        setLoading(false)
        setEmiFileUpload(true)
        setFileId(bulkOnboardfileUploadHandler?.data?.data?.id)
        setPercent(100)
      } else if (bulkOnboardfileUploadHandler.state === 'rejected') {
        setFilename('')
        setWsData(undefined)
        setLoading(false)
        setPercent(0)
        setFileId('')
      }
    }, [bulkOnboardfileUploadHandler?.data, bulkOnboardfileUploadHandler.state, setEmiFileUpload])

    // FIXME: update with dev!
    const readExcel = async (file: any, name: string) => {
      setFileUploaded(false)
      if (!file) {
        setFilename(name)
        setWsData(undefined)
        setLoading(false)
        setPercent(0)
        return
      }
      const initialTime = new Date().getTime()
      setLoading(true)
      setPercent(10)
      if (fileType !== '' && type !== 'documentation') {
        const readPromise = new Promise((resolve, reject) => {
          XlsxPopulate.fromDataAsync(file).then(function (workbook) {
            const sheet = workbook.sheet(0)
            const rows = sheet._rows
            const keys: any = []
            const values: any = []
            setPercent(30)
            rows.forEach((row: any, rowIndex: number) => {
              const obj: any = {}
              row._cells.forEach((cell: any, index: number) => {
                if (type === 'bulkStore' || type === 'bulkTerminal') {
                  if (rowIndex == 1) {
                    return true
                  }
                  if (rowIndex === 2) {
                    keys.push(`${cell.value()}`)
                  } else {
                    const key = keys[index - 1]
                    obj[key] = `${cell.value() || ''}`
                  }
                } else {
                  const headerIndex = getHeaderIndex(type)

                  if (rowIndex === headerIndex) {
                    keys.push(`${cell.value()}`)
                  } else {
                    const key = keys[index - 1]
                    obj[key] = `${cell.value() || ''}`
                  }
                }
              })
              if (
                ![
                  'MCC_EXPORT',
                  'IFSC_EXPORT',
                  'PINCODE_EXPORT',
                  'PROGRAM_CATEGORY_EXPORT',
                  'BULK_TERMINAL_UPDATE',
                  'BULK_TERMINAL_UPDATE',
                  'BULK_STORE_UPDATE',
                  'ADD_MERCHANT_MAPPING',
                  'BULK_KEY_EXCHANGE_UPLOAD',
                ].includes(type)
              ) {
                !isEmptyObject(obj) && values.push(obj)
              } else if (type === 'BULK_STORE_UPDATE' && ![1, 2].includes(rowIndex)) {
                !isEmptyObject(obj) && values.push(obj)
              } else if (type !== 'BULK_STORE_UPDATE' && rowIndex !== 1) {
                !isEmptyObject(obj) && values.push(obj)
              }
            })
            setPercent(50)
            const mismatchedColumns =
              columns(type).length === keys.length
                ? columns(type).filter((item, index) => item !== keys[index])
                : columns(type)
            console.log('mismatchedColumns', mismatchedColumns)
            if (mismatchedColumns?.length === 0 && values.length > 0) {
              console.log('workbook', workbook)
              console.log('values', values)
              setFilename(name)
              setWsData(workbook)
              setEmiInfo(values)
              resolve(values)
              bulkOnboardUploadFile(file, type)
            } else {
              reject('Invalid File')
              setFilename('')
              setWsData(undefined)
              setLoading(false)
              setPercent(0)
              setFileId('')
            }
          })
        })
        try {
          await readPromise
        } catch (e) {
          setMessage(e, MessageTypes.ERROR)
        }
      } else {
        if (type === 'documentation') {
          setPercent(30)
          addDocument({
            NAME: name,
            MERCHANT_DOCUMENT_TYPE: documentFormData?.MERCHANT_DOCUMENT_TYPE,
            MERCHANT_DOCUMENT_NAME: documentFormData?.MERCHANT_DOCUMENT_NAME,
            RID: documentFormData?.RID,
            expiry: documentFormData?.expiry,
            deleteOnly: 'deleteOnly',
          })
          if (uploadId?.length === 0) {
            fetchKycUploadId()
            setFile(file)
            setPercent(60)
          } else {
            setPercent(70)
            uploadKyc(
              file,
              documentFormData?.MERCHANT_DOCUMENT_TYPE,
              documentFormData?.RID,
              flowType === 'AD_MAKER' ? documentFormData?.NAME : documentFormData?.MERCHANT_DOCUMENT_NAME,
              documentFormData?.expiry,
              flowType === EmType.createGroup
                ? 'GROUP'
                : flowType === EmType.createSubGroup
                ? 'SUBGROUP'
                : flowType === EmType.createSingleEntity
                ? 'ENTITY'
                : 'REDACT',
              uploadId,
              identificationNumber,
            )
            setFile(file)
          }
        }
      }
    }

    const onSubmitPress = useCallback(() => {
      updateUploadedExcelFile && updateUploadedExcelFile(emiInfo)
      onReviewPressed && onReviewPressed(true)
      updateFileName && updateFileName(filename)
    }, [emiInfo, filename, onReviewPressed, updateFileName, updateUploadedExcelFile])

    const onOutlineButtonPress = useCallback(() => {
      setFilename('')
      setWsData(undefined)
      setLoading(false)
      setPercent(0)
      onReviewPressed && onReviewPressed(false)
      if (fileId?.length > 0) {
        bulkOnboardingDelete(fileId, type)
      }
    }, [bulkOnboardingDelete, fileId, onReviewPressed, type])

    const onSampleDownload = () => {
      sampleFileDownload(getSampleFileName(type))
    }
    const abortControllerRef: any = useRef({})

    const getAbortController = useCallback(() => {
      abortControllerRef.current.abortController = new AbortController()
      console.log('htag getAbortController ', abortControllerRef.current)
      return abortControllerRef.current
    }, [])

    useEffect(
      () => () => {
        if (abortControllerRef && abortControllerRef.current) {
          abortControllerRef.current.abortRecursive = true
        }
      },
      [],
    )

    const onDownloadExistingRecordPress = useCallback(() => {
      lazyDownloadExistingLovRecords({ jobType: type }, getAbortController)
    }, [lazyDownloadExistingLovRecords, type, getAbortController])

    const showToast = (msg: string) => {
      setMessage(msg, MessageTypes.ERROR)
    }

    return (
      <>
        <Box
          alignSelf={'center'}
          justify="center"
          f={1}
          bg="WHITE"
          overflow={'auto'}
          w={'50%'}
          ph={40}
          pv={30}
          minWidth={500}
          minHeight={500}>
          <TextNew hide={percent > 90} title={title ?? 'Upload your EMI excel file'} {...styles.titleText} />
          <Spacer size={32} direction={'vertical'} />
          <Box w={'100%'} maxWidth={550} alignSelf="center">
            <FileSelector
              innerCompTitle={dropText ?? 'Drop your EMI excel file here or'}
              innnerCompSubtitle={'Click to upload'}
              onFileSelect={readExcel}
              fileType={fileType}
              fileId={fileId}
              filename={filename}
              isLoading={loading}
              onCancelPress={onOutlineButtonPress}
              percent={percent}
              showRemoveFile={showRemoveFile}
              InnerComp={FileSelectorInnerComp}
              showToast={showToast}
              onDismiss={onDismiss}
            />
            <Spacer size={16} direction={'vertical'} />
            <ModBox
              show={
                (!loading && type === 'bulkUpload') ||
                type === 'tid' ||
                type === 'bulkConfig' ||
                type === 'bulkCard' ||
                type === 'bulkVpa' ||
                type === 'bulkStore' ||
                type === 'bulkTerminal' ||
                type === 'MCC_EXPORT' ||
                type === 'IFSC_EXPORT' ||
                type === 'PINCODE_EXPORT' ||
                type === 'PROGRAM_CATEGORY_EXPORT' ||
                type === 'BULK_STORE_UPDATE' ||
                type === 'BULK_DEVICES' ||
                type === 'BULK_TERMINAL_UPDATE' ||
                type === 'ADD_MERCHANT_MAPPING' ||
                type === 'APPROVE_MERCHANT_MAPPING' ||
                type === 'BULK_USER_MANAGEMENT'
              }
              flexWrap="wrap"
              align={'center'}
              alignSelf="center">
              <Text fontFamily={'jiotype-medium'} fontSize={12} color={'DARK_GREY'}>
                {'Input File format should be as per the Sample File format.'}
              </Text>
              <Spacer size={12} />

              <Box flexDirection={'row'} align={'center'} onPress={onSampleDownload} underlayColor={'GRAY_SHADOW'}>
                <Icon id={'IMPORT'} color={'BLUE_SHADE_PRIMARY'} />
                <Spacer size={8} direction={'horizontal'} />
                <TextNew fontFamily={'jiotype-medium'} fontSize={12} color={'BLUE_SHADE_PRIMARY'}>
                  {type === 'bulkConfig'
                    ? 'Download Sample Bulk Config File'
                    : type === 'tid'
                    ? 'Download Sample Bulk Sync File'
                    : type === 'bulkCard'
                    ? 'Download Sample Bulk Cards File'
                    : type === 'bulkVpa'
                    ? 'Download Sample Bulk Vpas File'
                    : type === 'bulkStore'
                    ? 'Download Sample Bulk Store File'
                    : type === 'bulkTerminal'
                    ? 'Download Sample Bulk Terminal File'
                    : 'Download Sample  File'}
                </TextNew>
              </Box>
            </ModBox>
            <ModBox show={['MCC_EXPORT', 'IFSC_EXPORT', 'PINCODE_EXPORT', 'PROGRAM_CATEGORY_EXPORT'].includes(type)}>
              <ModBox
                flexDirection={'row'}
                align={'center'}
                onPress={onDownloadExistingRecordPress}
                underlayColor={'GRAY_SHADOW'}
                show={downloadExistingLovHandler.state !== 'pending'}
                justifyContent={'center'}>
                <Icon id={'IMPORT'} color={'BLUE_SHADE_PRIMARY'} />
                <Spacer size={8} direction={'horizontal'} />
                <TextNew fontFamily={'jiotype-medium'} fontSize={12} color={'BLUE_SHADE_PRIMARY'}>
                  {'Download existing Data'}
                </TextNew>
              </ModBox>
              {downloadExistingLovHandler.state === 'pending' && <LoaderNew type={'small'} />}
            </ModBox>
            <Spacer size={16} />
            <ModBox show={isDefaultType} w={'100%'} alignItems={'center'}>
              <ButtonNew disabled={!wsdata} title={'Proceed'} type="primary" onPress={() => saveEmiInfoApi(emiInfo)} />
            </ModBox>
          </Box>
        </Box>
        <DualActionButtonComp
          hide={isDefaultType || type === 'documentation'}
          isOutlineButtonVisible={showOutlinedButton(loading, filename)}
          isColoredButtonVisible={true}
          isValid={filename?.length > 1}
          outlineButtonTitle={getOutlineButtonString(loading, filename)}
          coloredButtonText={coloredButtonString(filename)}
          onColoredButtonPress={onSubmitPress}
          onOutlineButtonPress={onOutlineButtonPress}
        />
        {type === 'BULK_USER_MANAGEMENT' && <UserDataDownloadComp />}
      </>
    )
  },
)
// TODO:: remove proceed button and handle from footer
export default EmiFileUpload
